export enum StorefrontWidgetPlacementContainer {
  SideCart = "side_cart",
  CartPage = "cart_page",
  PopupCart = "popup_cart",
  Other = "other",
}
